import { isHasArray, isRequiredText, isRequiredWithObj, strMax, } from '../../utils';
const makeValidateProjectCareerTitle = (name, isRequired) => [
    isRequired
        ? isRequiredText(`${name}を入力してください`)
        : isRequiredWithObj(`${name}を入力してください`, [
            'middleTasks',
            'content',
        ]),
    strMax(200, `${name}は200文字以内で入力してください`),
];
const makeValidateProjectCareerMiddleTasks = (isRequired) => [
    isRequired
        ? isRequiredText('テーマを入力してください')
        : isRequiredWithObj('テーマを入力してください', ['title', 'content']),
];
const makeValidateProjectCareerContent = (isRequired) => [
    isRequired
        ? isRequiredText('説明文を入力してください')
        : isRequiredWithObj('説明文を入力してください', ['middleTasks', 'title']),
    strMax(2000, '説明文は2000文字以内で入力してください'),
];
export default {
    free: {
        array: [isHasArray('プロジェクト経験は必須です')],
        content: makeValidateProjectCareerContent('説明文', true),
        position: [strMax(200, '役職は200文字以内で入力してください')],
        title: makeValidateProjectCareerTitle('プロジェクト名', true),
    },
    normal: {
        array: [
        // 2020-04-22 一時的に必須項目を減らします
        // isHasArray('プロジェクト実績は必須です'),
        ],
        content: makeValidateProjectCareerContent(false),
        middleTasks: makeValidateProjectCareerMiddleTasks(false),
        title: makeValidateProjectCareerTitle('プロジェクトテーマ名', false),
    },
};
